import { render, staticRenderFns } from "./Occurrence.vue?vue&type=template&id=79b38487&scoped=true&"
import script from "./Occurrence.vue?vue&type=script&lang=js&"
export * from "./Occurrence.vue?vue&type=script&lang=js&"
import style0 from "./Occurrence.vue?vue&type=style&index=0&id=79b38487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b38487",
  null
  
)

export default component.exports